import { deleteApiRequest } from 'api';

export const deleteTeacherMarks = (markIds: number[]): Promise<number[]> => {
    return deleteApiRequest('/teacher-mark/bulk-delete/', {
        data: markIds.map((id) => ({ id })),
    });
};
